/**
 * The wait at the end of onboarding, while `POST /api/matches/cold-start`
 * (PIVOT-081/082) scores the candidate's first shortlist against the live
 * corpus. Seconds, not milliseconds — a real judge model reads each offer — so
 * the wait is shown rather than hidden behind a spinner-less pause.
 *
 * Told as the funnel actually runs (filter → read → rank), because "we are
 * reading real offers against your profile" is the product promise doing its
 * first visible work.
 */

import { useI18n } from '../i18n'
import { PivotLogo } from './PivotLogo'
import { Thinking } from './Thinking'
import './OnboardingProgress.css'

export function OnboardingProgress() {
  const { t } = useI18n()

  return (
    <div className="onboarding-progress stack">
      <span className="onboarding-progress-mark">
        <PivotLogo />
      </span>
      {/* PIVOT-143 (review fix): this was an `h2`, which — combined with
          `MARKER.scoring` being `null` so `OnboardingSteps` never mounts on
          this screen — left the cold-start wait with zero `h1` in the whole
          document, violating the ticket's own unconditional "every step has
          exactly one h1" acceptance bullet. `.onboarding-progress-title`
          below re-pins the global `h1` face back down to this component's
          original h2-sized look, the same move `OnboardingSteps.css`'s
          `.onboarding-steps-current` makes for its own h1. */}
      <h1 className="onboarding-progress-title">{t('onboarding.scoringTitle')}</h1>
      <p className="onboarding-progress-body">{t('onboarding.scoringBody')}</p>
      {/* Carries the sweep, the live region, and — past ten seconds — the line
          that says why a real read of every offer is not instant. */}
      <Thinking wide patience="onboarding.scoringPatience" />
    </div>
  )
}
